import { useState } from "react"
import useFetchJson from "../../../data/useFetchJson"
import { MahiContext } from "../../state/MahiContext"
import { useContext } from "react"
import { useEffect } from "react"
import { Box } from "@mui/material"
import DocumentUploadBoxWithContext from "../../upload/DocumentUploadBoxWithContext"
import UpdatedGalleryViewer from "../../upload/UpdatedGalleryViewer"

export function DlspGenericFileUploadPanel({icp, bffBaseUrl, bffUploadPath, bffGetAllPath, bffDeletePath, fspStatusNoEdit}) {

    const [imageReloadCounter, setImageReloadCounter] = useState(0)
    // const bffUploadPath = `/bff/decommissioned-lines-service/api/decommissioned-lines/desktop-inspection-image/upload?icp=${icp}`
    // const bffGetAllPath = `/bff/decommissioned-lines-service/api/decommissioned-lines/desktop-inspection-image/get-all`
    // const bffDeletePath = `/bff/decommissioned-lines-service/api/decommissioned-lines/desktop-inspection-image/delete`

    const { data: allImages, load: loadAllImages, setData: setAllImages } = useFetchJson(bffGetAllPath)
    const { load: deleteImage } = useFetchJson(bffDeletePath)

    const mahiContext = useContext(MahiContext)

    useEffect(() => {
        if (!icp) {
            return
        }
        const loadImagesParams = { params: { icp } }
        loadAllImages(loadImagesParams) // run in background

    }, [icp, loadAllImages, imageReloadCounter])

    const handleRemoveImage = async (fileKey) => {
        console.log('DlspGenericFileUploadPanel handleRemoveImage', fileKey)

        const options = {
            method: 'DELETE',
            params: { fileKey: fileKey }
        }
        const deleteResponse = await deleteImage(options)
        console.log('DlspGenericFileUploadPanel deleteResponse', deleteResponse)

        if (deleteResponse !== undefined) {
            //
            // Attachment with given key was deleted successfully.
            // Remove it from the list of Hiko Image Thumbnails.
            //
            setAllImages(existingAttachments => existingAttachments.filter(a => a.fileKey !== fileKey))
        }
    }

    /**
     * 
     * @param {boolean} isUploaderBusy 
     * @param {object[]} changeFileSpecs E.g. [ { "action": "Add", "file": { "file": {}, "fileKey": "10024", "url": "somebaseUrl10024", "status": "Uploaded" } } ]
     */
    const handlePlanImageUploadStatusChange = (isUploaderBusy, changeFileSpecs) => {
        console.log('handlePlanImageUploadStatusChange isUploaderBusy, changeFileSpecs', isUploaderBusy, changeFileSpecs)

        if (changeFileSpecs.length > 0) {
            const addFileSpecs = changeFileSpecs.filter(cs => cs.action === 'Add');
            if (addFileSpecs.length > 0) {
                //
                // One or more files were added.
                // Refresh from the server in the hope it will include the new uploads.
                //
                setImageReloadCounter(c => c + 1) // trigger useEffect to reload images
            }
        }
    }

    return (
        <Box>
            <UpdatedGalleryViewer documents={allImages} bffBase={bffBaseUrl} remove={handleRemoveImage} options={{readOnly: fspStatusNoEdit? true : false}} />
            {!fspStatusNoEdit && <DocumentUploadBoxWithContext uploadPath={bffUploadPath} initialFiles={[]} statusChange={handlePlanImageUploadStatusChange} appContext={mahiContext} bffApi="bffMahi" />}        
        </Box>


    )
}